import * as React from 'react'

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const checkIsMobile = () => {
      // First check: User agent for mobile/tablet devices
      const userAgent =
        navigator.userAgent || navigator.vendor || (window as any).opera
      const isMobileDevice =
        /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
          userAgent.toLowerCase(),
        )

      // Second check: Touch capability (additional mobile indicator)
      const isTouchDevice =
        'ontouchstart' in window || navigator.maxTouchPoints > 0

      // Third check: Screen width fallback
      const isNarrowScreen = window.innerWidth < MOBILE_BREAKPOINT

      // Consider it mobile if it's a mobile device OR (has touch AND narrow screen)
      return isMobileDevice || (isTouchDevice && isNarrowScreen)
    }

    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)

    const onChange = () => {
      setIsMobile(checkIsMobile())
    }

    mql.addEventListener('change', onChange)
    setIsMobile(checkIsMobile())

    return () => mql.removeEventListener('change', onChange)
  }, [])

  return !!isMobile
}
